export { default } from './RequiredIcon';
